import { Injectable } from '@angular/core';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { EditCommandHandler } from '../../../core/service/command/edit-command-handler.service';
import { standardCommand } from '../../../core/model/command';
import { RentApplicationExportCommandHandler } from './rent-application-export-command-handler.service';
import { rentApplicationCommand } from '../../command/rent-application.command';

@Injectable()
export class RentApplicationCommandHandlerResolver extends CommandHandlerResolver {
  constructor(deleteHandler: DeleteCommandHandler, editHandler: EditCommandHandler, exportHandler: RentApplicationExportCommandHandler) {
    super();
    this.addHandler(standardCommand.delete, deleteHandler);
    this.addHandler(standardCommand.edit, editHandler);
    this.addHandler(rentApplicationCommand.export, exportHandler);
  }
}
